import { Domain } from "@hostingbv/lib/src/api/partner/models/Domain";
import { Server } from "@hostingbv/lib/src/api/partner/models/Server";
import { Site } from "@hostingbv/lib/src/api/partner/models/Site";
import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMessage } from "@fortawesome/free-solid-svg-icons";
import { HoverHint } from "@hostingbv/lib/src/components/content/HoverHint";
import { useModal } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { EditNotesModal } from "../modals/EditNotesModal";
import { usePermissions } from "@hostingbv/lib/src/auth/permissions";
import { useApiClient } from "../../../lib/src/api";
import { config } from "../config";
import { MailDomain } from "../../../lib/src/api/partner/models/MailDomain";

type AnyEntity = Domain | Site | Server | MailDomain
export const EntityNotesButton: FC<{ entity: AnyEntity | null, allowNew?: boolean }> = props => {
  const { partnerClient } = useApiClient(config)
  const { can } = usePermissions(partnerClient)
  if (props.entity === null || !can('view', 'notes')) {
    return <></>
  }
  if (props.entity.notes !== null) {
    if (!can('edit', 'notes')) {
      return <></>
    }
    return <EditNoteButton entity={props.entity} />
  }
  if (props.allowNew === false || !can('create', 'notes')) {
    return <></>
  }
  return <AddNoteButton entity={props.entity} />
}

export const AddNoteButton: FC<{ entity: AnyEntity }> = (props) => {
  const { open } = useModal({ title: "Add a note", body: <EditNotesModal entity={props.entity} /> })
  return <button className={"ml-3 text-slate-300 hover:text-slate-500"} onClick={open}>
    <HoverHint hint={'Add a note'}><FontAwesomeIcon icon={faMessage} /></HoverHint>
  </button>
}
export const EditNoteButton: FC<{ entity: AnyEntity }> = (props) => {
  const { open } = useModal({ title: "Edit note", body: <EditNotesModal entity={props.entity} /> })
  return <button className={"ml-3 text-brand-700"} onClick={open}>
    <HoverHint hint={props.entity.notes!}><FontAwesomeIcon icon={faMessage} /></HoverHint>
  </button>
}
